/**
 * CargaAryztaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaAryzta} from '@/model/resource/CargaAryzta'

/* TODO: review generated class */
@HttpExclude()
export class CargaAryztaCollection extends PageCollection<CargaAryzta> {
  constructor() {
    super(CargaAryzta)
  }

  queryAsPage() {
    return this.listCargaAryzta()
  }

  async listCargaAryzta() {
    return await Request.get(`/admin/carga-aryzta`, {params: this.params})
      .name('listCargaAryzta')
      .as(this)
      .getResponse()
  }

  async listCsvCargaAryzta() {
    return await Request.get(`/admin/carga-aryzta/csv`, {params: this.params})
      .name('listCsvCargaAryzta')
      .as(this)
      .getResponse()
  }
}
